export default __webpack_public_path__ + "96abe7119114c0ca6d66a0e6ac293684.svg";